import React, { useState } from 'react';
import ImageEditor from '@components/image-editor/image-editor.tsx';
import { useTranslation } from 'react-i18next';

function ImageCropEditorComponent() {
  const { t } = useTranslation();

  // 🟢 State for each image separately
  const [imageRoundedCrop, setImageRoundedCrop] = useState<string>(''); // Rounded + Crop
  const [imageRoundedNoCrop, setImageRoundedNoCrop] = useState<string>(''); // Rounded + No Crop
  const [imageSquareCrop, setImageSquareCrop] = useState<string>(''); // Not Rounded + Crop
  const [imageSquareNoCrop, setImageSquareNoCrop] = useState<string>(''); // Not Rounded + No Crop

  return (
    <div className="flex flex-wrap gap-16">
      {/* 🟢 1️⃣ Rounded + Crop */}
      <div className="media-wrapper">
        <div className="flex justify-center items-center mb-1.5">
          <span className="required-symbole">*</span>
          {t('label_image')}
        </div>
        <ImageEditor
          imagePath={imageRoundedCrop}
          onImagePathCropped={(path) => setImageRoundedCrop(path)}
          isRounded={true}
          showCropPopup={true}
        />

        <p className="font-medium mt-8 text-gray-700">🟢 Rounded + Crop</p>
      </div>

      {/* 🟡 2️⃣ Rounded + No Crop */}
      <div className="media-wrapper">
        <div className="flex justify-center items-center mb-1.5">
          {t('label_image')}
        </div>
        <ImageEditor
          imagePath={imageRoundedNoCrop}
          onImagePathCropped={(path) => setImageRoundedNoCrop(path)}
          isRounded={true}
          showCropPopup={false}
        />

        <p className="font-medium mt-8 text-gray-700">🟡 Rounded + No Crop</p>
      </div>

      {/* 🔵 3️⃣ Not Rounded + Crop */}
      <div className="media-wrapper">
        <div className="flex mb-1.5">
          <span className="required-symbole">*</span>
          {t('label_image')}
        </div>
        <ImageEditor
          imagePath={imageSquareCrop}
          onImagePathCropped={(path) => setImageSquareCrop(path)}
          isRounded={false}
          showCropPopup={true}
        />

        <p className="font-medium mt-8 text-gray-700">🔵 Not Rounded + Crop</p>
      </div>

      {/* 🟠 4️⃣ Not Rounded + No Crop */}
      <div className="media-wrapper">
        <div className="flex mb-1.5">{t('label_image')}</div>
        <ImageEditor
          imagePath={imageSquareNoCrop}
          onImagePathCropped={(path) => setImageSquareNoCrop(path)}
          isRounded={false}
          showCropPopup={false}
        />

        <p className="font-medium mt-8 text-gray-700">
          🟠 Not Rounded + No Crop
        </p>
      </div>
    </div>
  );
}

export default ImageCropEditorComponent;
